module.exports = "<dk-k-currency-rates-column></dk-k-currency-rates-column>\r\n";